export const operations = {
  add: "ADD",
  decrease: "DECREASE",
};
